import React from "react";
import { Escalation } from "../../../types";
import { formatLocalDate, getOrdinalSuffix } from "utils/helper";
import { SENTIMENT_SCORE_MAPPER } from "../../TaskCenter/components/TaskCenterTable";
import { CardEscalationSurvey } from "subframe/components/CardEscalationSurvey";

export const ESCALATION_STATUS_MAP: Record<string, { label: string, variant: any }> = {
  at_risk: {
    label: "Action Needed",
    variant: "action-needed"
  },
  in_progress: {
    label: "In Progress",
    variant: "in-progress"
  },
  resolved: {
    label: "Resolved",
    variant: "resolved"
  },
  dismissed: {
    label: "Dismissed",
    variant: "dismissed-expired"
  },
  expired: {
    label: "Expired",
    variant: "dismissed-expired"
  },
  // Optional: fallback/default
  default: {
    label: "Default",
    variant: "default"
  }
};

interface EscalationSectionProps {
  escalation: Escalation;
  isLoading?: boolean;
}

const EscalationSectionSkeleton: React.FC = () => (
  <div className="flex w-full flex-col items-start gap-4 rounded-lg bg-error-50 px-4 py-4">
    <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div className="h-6 w-48 bg-neutral-200 rounded animate-pulse" />
      <div className="h-6 w-24 bg-neutral-200 rounded-full animate-pulse" />
    </div>
    <div className="flex flex-col items-start gap-1">
      <div className="h-4 w-32 bg-neutral-200 rounded animate-pulse" />
    </div>
  </div>
);

export const EscalationSection: React.FC<EscalationSectionProps> = ({
  escalation,
  isLoading = false,
}) => {
  if (isLoading) {
    return <EscalationSectionSkeleton />;
  }

  const { label, variant } = ESCALATION_STATUS_MAP[escalation.status as keyof typeof ESCALATION_STATUS_MAP] ?? ESCALATION_STATUS_MAP.default;

  return (
    <CardEscalationSurvey
      title={`Escalation - ${escalation.surveyTitle}`}
      date={formatLocalDate(escalation.createdAt)}
      escalationLevel={escalation.level}
      cause={SENTIMENT_SCORE_MAPPER[escalation.reason as keyof typeof SENTIMENT_SCORE_MAPPER] ?? escalation.reason}
      variant={variant}
      ticketStatus={label}
    />
  );
};

